var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMinimize = function SvgMinimize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "minimize_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1112 0v251H0V0h1112Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "minimize_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.93 9.001.03.027.012.013a.804.804 0 0 1 .217.424l.008.067.001.013.001.026.001.029v4.8a.8.8 0 1 1-1.6 0v-2.87l-4.234 4.236a.8.8 0 0 1-1.042.077l-.09-.077a.8.8 0 0 1 0-1.132L4.468 10.4H1.6a.8.8 0 0 1-.794-.7L.8 9.6a.8.8 0 0 1 .8-.8h4.8a.816.816 0 0 1 .197.024l.078.024a.8.8 0 0 1 .193.103l.032.025.066.058-.036-.033ZM8.8 1.6a.8.8 0 1 1 1.6 0v2.868L14.634.234a.8.8 0 0 1 1.042-.077l.09.077a.8.8 0 0 1 0 1.132L11.53 5.599 14.4 5.6a.8.8 0 0 1 .794.7l.006.1a.8.8 0 0 1-.8.8H9.583a.803.803 0 0 1-.18-.024l-.078-.024a.8.8 0 0 1-.193-.103L9.1 7.023l-.056-.05.039.037.029.023a.804.804 0 0 1-.07-.06l-.007-.007a.816.816 0 0 1-.213-.385.87.87 0 0 1-.01-.046l-.008-.067-.001-.018.001.018L8.8 6.4V1.6Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#minimize_svg__a)",
    transform: "translate(-167 -24)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#minimize_svg__b)",
    transform: "translate(167 24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0V0z"
  })))));
};

export default SvgMinimize;